import { useContext } from 'react'
import { Helmet } from 'react-helmet-async'

import { faGlobe } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Button, Columns, DashboardModule, LoadingModule,
} from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import { generateUrls } from '@hooks/usePublication'
import usePublications from '@hooks/usePublications'

import ListBlankState from '@components/ListBlankState'
import PageFilterModule from '@components/PageFilterModule'
import PageHeader from '@components/PageHeader'

import PublicationListItem from '../PublicationListItem'

const requestOptions = {
  include_publication_provider: true,
}

const buildPageFilterFields = () => {
  const style = { marginBottom: 16 }
  const boxProps = { marginBottom: 'large' }

  return [
    {
      component: 'DynamicInput',
      componentProps: {
        inputComponent: 'input',
        style,
      },
      key: 'string',
      label: 'Filter by Title or ID',
    },
    {
      callbacks: {
        buildSearchRequestOptions: () => ({ publication_providers: true }),
      },
      component: 'EntitySelector',
      componentProps: {
        boxProps,
        entityKey: 'providers',
      },
      key: 'provider_id',
    },
  ]
}

interface PageContentProps {
  pageFilters: {
    [key: string]: any,
  },
}

const PageContent = (props: PageContentProps) => {
  const { pageFilters } = props

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredPublications,
    filteredPublicationsCount,
    hasFilteredPublications,
    loading,
  } = usePublications({ filters: pageFilters, performHttpRequests: true, requestOptions })

  const pageContext = useContext(PageContext)
  const {
    callbacks: {
      resetFilters,
      showCreatePublicationModal,
      updateFilters,
    },
    defaultFilters,
  } = pageContext

  const { publicationsIndexUrl } = generateUrls()

  return (
    <>
      <Helmet>
        <title>Publications | Realhub</title>
      </Helmet>

      <PageHeader
        actionContent={(
          <Button
            buttonStyle="primaryCreate"
            onClick={() => showCreatePublicationModal()}
            size="medium"
          >
            Create
          </Button>
        )}
        activeTabBarItemKey="publications"
        tabBarItems={[
          {
            href: publicationsIndexUrl,
            icon: faGlobe,
            key: 'publications',
            title: 'Publications',
          },
        ]}
        title="Publications"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          <Columns.Main>
            {/*
             // @ts-expect-error TS2322 */}
            <LoadingModule loading={loading} times={3} />

            {!loading && !hasFilteredPublications && <ListBlankState />}

            {!loading && hasFilteredPublications && (
              <DashboardModule contentBoxProps={{ flexDirection: 'column' }} title="Publications">
                <Box flexDirection="column">
                  {filteredPublications.map(publication => (
                    <PublicationListItem key={publication.id} publication={publication} />
                  ))}
                </Box>

                <DashboardModule.LoadMoreFooter
                  callbacks={{ loadMore }}
                  canLoadMore={canLoadMore}
                  entityCount={filteredPublicationsCount}
                  // @ts-expect-error TS2322
                  loading={loading}
                />
              </DashboardModule>
            )}
          </Columns.Main>

          <Columns.Sidebar>
            <PageFilterModule
              callbacks={{ resetFilters, updateFilters }}
              defaultFilters={defaultFilters}
              // @ts-expect-error TS2322
              filterFields={buildPageFilterFields()}
              pageFilters={pageFilters}
              title="Filters"
            />
          </Columns.Sidebar>
        </Columns>
      </Box>
    </>
  )
}

export default PageContent
